import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { useDashLayoutCtx } from "../DashLayoutCtxProvider";
import COLORS from "../../../../constants/Colors";
import WheelzTextInput from "../../../common/inputs/WheelzTextInput";
import APP_CONSTANTS from "../../../../constants/AppConstants";
import notify from "../../../../funcs/ToastFuncs";
import NumPlateIcon from "../../../../assets/images/number_plate_icon.png";
import WheelzButton from "../../../common/buttons/WheelzButton";
import SavedTruckList from "./SavedTruckList";

const VehicleNoAdornment = () => {
  const { splitView } = useDashLayoutCtx();
  return (
    <Box
      sx={{
        height: "68px",
        width: "85px",
        background: splitView ? "grey" : COLORS.PRIMARY,
        mr: "20px",
        ml: "-10px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          height: "25px",
          width: "25px",
          backgroundImage: `url(${NumPlateIcon})`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      />
      <Typography fontSize={"1rem"} fontWeight={500} color="white">
        IND
      </Typography>
    </Box>
  );
};

const TruckSearchPanel = ({ vehRegNo, setRegNo }) => {
  const [inputVehRegNo, setinputVehRegNo] = useState("");
  const { splitView, setsplitView } = useDashLayoutCtx();
  const initSearch = () => {
    if (APP_CONSTANTS.VEHICLE_REG_NO_REGEX.test(inputVehRegNo)) {
      setRegNo(inputVehRegNo);
      setsplitView(true);
    } else {
      notify("Invalid vehicle number", "error");
    }
  };
  const handleVehRegNoChange = (event) => {
    let inputValue = event.target.value;
    if (inputValue.length > APP_CONSTANTS.VEHICLE_NO_MAX_LENGTH) {
      inputValue = inputValue.slice(0, APP_CONSTANTS.VEHICLE_NO_MAX_LENGTH);
    }
    setinputVehRegNo(inputValue.toUpperCase());
  };
  useEffect(() => {
    if (!vehRegNo) {
      setinputVehRegNo("");
    }
  }, [vehRegNo]);

  return (
    <Box
    sx={{
      height:"100%",
      width: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <Typography
      fontSize={"1.4rem"}
      fontWeight={400}
      color={COLORS.PRIMARY}
      sx={{
        userSelect: "none",
      }}
    >
      Search with vehicle number
    </Typography>
    <Box
      onClick={() => {
        if (inputVehRegNo && splitView) {
          setRegNo(null);
          setsplitView(false);
        }
      }}
    >
      <WheelzTextInput
        value={inputVehRegNo}
        onChange={handleVehRegNoChange}
        width="300px"
        disabled={splitView}
        showAdornment
        noLabel
        customStartAdornment={<VehicleNoAdornment />}
        placeholder="AB 12 CD 3456"
        fontSize={"1.5rem"}
        letterSpacing={inputVehRegNo ? "5px" : null}
        sx={{
          mt: "20px",
          mb: "20px",
          pointerEvents: splitView ? "none" : "auto", // Disable pointer events when disabled
        }}
        onEnterFunc={inputVehRegNo && initSearch}
      />
    </Box>
    <WheelzButton
      buttonText={"Search"}
      width="300px"
      onClick={initSearch}
      disabled={splitView || !inputVehRegNo}
      sx={{ mb: "20px" }}
    />
    <Typography
      fontSize={"1rem"}
      fontWeight={400}
      sx={{
        userSelect: "none",
        opacity: 0.6,
      }}
    >
      Search is limited to trucks
    </Typography>
    <Box
      sx={{
        width: "100%",
        display:"none"
      }}
    >
      <SavedTruckList
        setRegNo={setRegNo}
        setInputField={setinputVehRegNo}
      />
    </Box>
  </Box>
  );
};

TruckSearchPanel.propTypes = {
  setRegNo: PropTypes.func.isRequired,
};

export default TruckSearchPanel;
